import { useEffect, useState } from 'react'
import { supabase } from '../../lib/supabaseClient'
import { UsersAdmin } from './Users'

interface FlagRow {
  key: string
  description: string | null
  enabled: boolean
  targeting: any
}

export function AdminHome() {
  const [flags, setFlags] = useState<FlagRow[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    const load = async () => {
      setLoading(true)
      const { data } = await supabase.from('feature_flags').select('*').order('key')
      if (!mounted) return
      setFlags((data as any[]) ?? [])
      setLoading(false)
    }
    load()
    return () => { mounted = false }
  }, [])

  const toggle = async (key: string, enabled: boolean) => {
    setFlags((prev) => prev.map((f) => (f.key === key ? { ...f, enabled } : f)))
    await supabase.from('feature_flags').update({ enabled }).eq('key', key)
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-2xl font-bold mb-6">Admin</h1>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="card">
            <h2 className="text-xl font-semibold mb-4">Feature Flags</h2>
            {loading ? (
              <div className="text-gray-600">Loading...</div>
            ) : (
              <div className="space-y-3">
                {flags.map((f) => (
                  <div key={f.key} className="flex items-center justify-between">
                    <div>
                      <div className="font-medium">{f.key}</div>
                      {f.description && <div className="text-sm text-gray-600">{f.description}</div>}
                    </div>
                    <label className="inline-flex items-center cursor-pointer">
                      <input type="checkbox" className="sr-only peer" checked={!!f.enabled} onChange={(e) => toggle(f.key, e.target.checked)} />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:bg-green-500 relative after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full" />
                    </label>
                  </div>
                ))}
              </div>
            )}
          </div>
          <UsersAdmin />
        </div>
      </div>
    </div>
  )
}


